module.exports = __webpack_public_path__ + "img/dropdownicon2.234aa063.svg";